import { ProcessedSequenceItemsGetRequestParams } from "@lib/core";

export interface ProcessedSequenceItemDefaultParams extends ProcessedSequenceItemsGetRequestParams { }
export class ProcessedSequenceItemDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}